import {
	ContextService,
	GamedayApiService
} from "@prestosports/prestostats-core/Services";
import {
	UPDATE_TEAM_CONTEXT_PLAYER,
	UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE
} from "./constants";
import {
	SET_CAPTAIN_COMPLETE,
	TOGGLE_ACTIVE_COMPLETE,
	TOGGLE_PARTICIPANT_COMPLETE,
	TOGGLE_STARTER_COMPLETE
} from "./flag-football-constants";
import GamedayApiClient from "../../services/gameday-api-client";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

export const addPosition = async (teamContext, player, position, dispatch) => {
	dispatch({ type: UPDATE_TEAM_CONTEXT_PLAYER });

	player.addPosition(position);

	dispatch({
		type: UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE,
		payload: { teamContext, player }
	});
};

export const removePosition = async (
	teamContext,
	player,
	position,
	dispatch
) => {
	dispatch({ type: UPDATE_TEAM_CONTEXT_PLAYER });

	player.removePosition(position);

	dispatch({
		type: UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE,
		payload: { teamContext, player }
	});
};

export const toggleStarter = async (gameId, teamId, player, dispatch) => {
	const gameContext = await ContextService.getGameContext(gameId);
	const teamContext = gameContext.getTeamContext(teamId);

	if (teamContext.isStarter(player)) {
		teamContext.removeStarter(player);
	} else {
		teamContext.addStarter(player);
	}

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: TOGGLE_STARTER_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};

export const toggleParticipant = async (gameId, teamId, player, dispatch) => {
	const gameContext = await ContextService.getGameContext(gameId);
	const teamContext = gameContext.getTeamContext(teamId);

	if (teamContext.isParticipant(player)) {
		teamContext.removeParticipant(player);
	} else {
		teamContext.addParticipant(player);
	}

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: TOGGLE_PARTICIPANT_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};

export const toggleActive = async (gameId, teamId, player, dispatch) => {
	const gameContext = await ContextService.getGameContext(gameId);
	const teamContext = gameContext.getTeamContext(teamId);

	if (teamContext.isActive(player)) {
		teamContext.removeActive(player);
	} else {
		teamContext.addActive(player);
	}

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: TOGGLE_ACTIVE_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};

export const setCaptain = async (gameId, teamId, player, dispatch) => {
	const gameContext = await ContextService.getGameContext(gameId);
	const teamContext = gameContext.getTeamContext(teamId);

	teamContext.setCaptain(player);

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: SET_CAPTAIN_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};
